export enum Web3ProviderEnum {
    METAMASK = 'metamask',
    COINBASE = 'coinbase',
}
